module.exports = "/_next/static/images/eth-b3aaa7ed0dc8fd54fdc8fcf408ca27cf.png";